export default __webpack_public_path__ + "static/media/SJA1510.34I-42084_-25229_0.43b914af.jpg";